export default "__VITE_ASSET__EqGar3HU__"